module.exports = __webpack_public_path__ + "static/media/birdbrain9.66477714.jpg";